
import $util from '../util/requestUtil'
const md5 = require('./md5.js');
import _this from '@/main.js'
// const url = 'http://192.168.0.113:8085/api/v2'
let info = {}
// 获取token
function dialInit(data) {
    info = data
    let that = _this;
    let params = {
        that: _this,
        method: 'POST',
        url: `${info.CTIServer}/call/auth`,
        headers: {
            "Content-Type": "application/json;"
        },
        data: {
            // "username": info.loginName,
            // "password": md5.hexMD5(info.password)
            "username":"api",
            "password":"8a5da52ed126447d359e70c05721a8aa"
        },
        cb(res) {
            // console.log('res :>> ', res);
            if (res.code == '0') {
                // console.log(res.result);
                window.localStorage.setItem('dialToken', res.resultBody.token);
                $("#stausDiv").html('预备拨号');
            } else {
                // that.$message.error(res.msg);
            }
        }
    };
    $util.request(params);
}

function Dial(Phone) {
    let that = _this;
    let params = {
        that: _this,
        method: 'POST',
        url: `${info.CTIServer}/call/outside`,
        headers: {
            "Content-Type": "application/json;"
        },
        data: {
            "exit": info.clientid,
            "calledid": Phone,
            "token": window.localStorage.getItem('dialToken')
        },
        cb(res) {
            if (res.code == '0') {
                return true
            } else {
                return false
            }
        }
    };
    $util.request(params);
}

export default {
    dialInit, 
    Dial
}